import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

type AuthContextType = {
  token: string | null;
  agencyId: string | null;
  login: (token: string, agencyId: string) => void;
  logout: () => void;
  isLoading: boolean;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string | null>(null);
  const [agencyId, setAgencyId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedToken = sessionStorage.getItem("REACT_APP_TOKEN");
    const storedAgencyId = sessionStorage.getItem("REACT_APP_AGENCY_ID");

    if (storedToken && storedAgencyId) {
      setToken(storedToken);
      setAgencyId(storedAgencyId);
    }

    setIsLoading(false);
  }, []);

  const login = (token: string, agencyId: string) => {
    setToken(token);
    setAgencyId(agencyId);
    sessionStorage.setItem("REACT_APP_TOKEN", token);
    sessionStorage.setItem("REACT_APP_AGENCY_ID", agencyId);

    setTimeout(() => {
      logout();
    }, 3600 * 1000);
  };

  const logout = () => {
    setToken(null);
    setAgencyId(null);
    sessionStorage.removeItem("REACT_APP_TOKEN");
    sessionStorage.removeItem("REACT_APP_AGENCY_ID");
  };

  return (
    <AuthContext.Provider value={{ token, agencyId, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};

export const authenticateUser = async (username: string, password: string) => {
  try {
    const response = await fetch('https://ad-insights-api-0f2fcea0deda.herokuapp.com/api/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: username, password }),
    });

    const data = await response.json();

    if (response.ok && data.access_token && data.user.agency.id) {
      return { token: data.access_token, agencyId: data.user.agency.id };
    } else {
      console.error(data);
      throw new Error(data.message || 'Autenticação falhou');
    }
  } catch (error) {
    console.error(error);
    throw new Error('Usuário ou Senha Incorreto');
  }
};